import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import {environment} from '../environments/environment';
import { ProjectHttpInterceptor } from './project-http-interceptor';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HashLocationStrategy, LocationStrategy} from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// PrimeNG Components for demos
import { ConfirmationService } from 'primeng/api';
import { CardModule } from 'primeng/card';
import { MessagesModule } from 'primeng/messages';
import { ButtonModule } from 'primeng/button';
import { ListboxModule } from 'primeng/listbox';
import { MessageModule } from 'primeng/message';
import { InputTextModule } from 'primeng/inputtext';
import { InputMaskModule } from 'primeng/inputmask';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { FileUploadModule } from 'primeng/fileupload';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { DropdownModule } from 'primeng/dropdown';


// Layouts
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';

// Application Components
import { InicioComponent } from './views/inicio/inicio.component';
import { RegistroEstablecimientoComponent } from './views/form-registro/registro/registro-establecimiento.component';

// Dynamic Forms
import {DynamicFormsModule} from 'dynamic-forms-lib';

// Guards
import { UnsavedChangesGuard } from './views/form-component/unsaved-changes.guard';

// Modules
import { ListaModule } from './views/lista-procesos/lista.module';
import { UserModule } from './views/user/user.module';
import { ComponentsModule } from './views/components/components.module';
import { MenuService } from './views/components/menu/app.menu.service';
import { AuthModule } from './views/auth/auth.module';
import { CheckboxModule } from 'primeng/checkbox';
import { RadioButtonModule } from 'primeng/radiobutton';

import { Dialog, DialogModule } from 'primeng/dialog';

@NgModule({
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    AuthLayoutComponent,
    InicioComponent,
    RegistroEstablecimientoComponent,
  ],
  exports: [
  ],
  imports: [
    BrowserModule,
    FormsModule,
    DynamicFormsModule.forRoot(environment),
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    ListaModule,
    UserModule,
    ComponentsModule,
    AuthModule,
    CardModule,
    MessagesModule,
    ListboxModule,
    MessageModule,
    InputMaskModule,
    InputSwitchModule,
    InputTextModule,
    InputTextareaModule,
    FileUploadModule,
    ConfirmDialogModule,
    ProgressSpinnerModule,
    ButtonModule,
    BreadcrumbModule,
    DropdownModule,
    CheckboxModule,
    RadioButtonModule,
    DialogModule,
  ],
  providers: [
    {provide: LocationStrategy, useClass: HashLocationStrategy},
    {provide: HTTP_INTERCEPTORS, useClass: ProjectHttpInterceptor, multi: true},
     MenuService,
    UnsavedChangesGuard,
    ConfirmationService,
    DialogModule,
  ],
  bootstrap: [AppComponent],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AppModule { }
